import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthProvider';
import React, { FC } from 'react';

interface PublicRouteProps {
  children: React.ReactNode;
}

const PublicRoute: FC<PublicRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to='/home' replace />;
  }

  return <>{children}</>; // Wrapping children in a fragment ensures it returns a valid React element
};

export default PublicRoute;
